module.exports = __webpack_public_path__ + "static/img/2.5bbf78e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/2.png
// module id = J2p6
// module chunks = 0